






















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import { FormSelectOption } from '~/types/ui';

export default defineComponent({
  inheritAttrs: false,
  model: {
    prop: 'modelValue',
    event: 'input',
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop, vue/require-prop-types
    modelValue: {},
    options: {
      type: Array as PropType<FormSelectOption[]>,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const localValue = computed({
      get() {
        return props.modelValue ?? null;
      },
      set(value) {
        emit('input', value);
      },
    });

    const activeOption = computed(() => props.options.find(({ value }) => localValue.value === value));
    const activeText = computed(() => {
      if (!activeOption.value) {
        return props.placeholder;
      }

      return activeOption.value.text || activeOption.value.value;
    });

    return {
      localValue,
      activeOption,
      activeText,
    };
  },
});
